import React, { useCallback, useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { ArrowLeft, LogOut, Eye } from 'lucide-react';
import { authAPI } from '../../utils/adminAPI';
import { adminEnquetesAPI } from '../../utils/adminEnquetesAPI';
import ConfigurarEnqueteForm from '../../components/admin/ConfigurarEnqueteForm';
import PerguntasBuilder from '../../components/admin/PerguntasBuilder';

// Página cheia — só alcançada pelo fluxo "Nova enquete" (criar rascunho e
// montar do zero, com pré-visualização disponível). Editar algo já
// existente acontece via os modais "Configurar Enquete"/"Editar Perguntas"
// em GerenciarEnquetes.js, que reaproveitam os mesmos dois componentes
// (ConfigurarEnqueteForm/PerguntasBuilder) renderizados aqui.
const EditorEnquete = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquete, setEnquete] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogout = async () => {
    await authAPI.logout();
    navigate('/admin/login');
  };

  const carregarCabecalho = useCallback(async () => {
    try {
      const dados = await adminEnquetesAPI.obter(id);
      setEnquete(dados);
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao carregar enquete');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    carregarCabecalho();
  }, [carregarCabecalho]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><div className="loading-spinner" /></div>;
  }

  if (!enquete) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Enquete não encontrada.</div>;
  }

  return (
    <div className="min-h-screen bg-corumba-light">
      <Toaster position="top-center" />

      <header className="bg-primary-600 text-white px-6 py-4 flex items-start justify-between">
        <div>
          <Link to="/admin/gerenciar-enquetes" className="flex items-center gap-2 text-sm hover:underline mb-2">
            <ArrowLeft className="w-4 h-4" /> Voltar
          </Link>
          <h1 className="text-lg font-bold">{enquete.titulo}</h1>
          <p className="text-xs text-primary-100">
            /e/{enquete.slug} — só acessível publicamente por quem não está logado
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Link to={`/admin/enquetes/${id}/preview`} className="flex items-center gap-2 text-sm hover:underline">
            <Eye className="w-4 h-4" /> Pré-visualizar
          </Link>
          <button onClick={handleLogout} className="flex items-center gap-2 text-sm hover:underline">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-6 space-y-6">
        <div className="card">
          <h2 className="font-semibold text-gray-900 mb-4">Configurações da enquete</h2>
          <ConfigurarEnqueteForm enqueteId={id} onSalvo={carregarCabecalho} />
        </div>

        <PerguntasBuilder enqueteId={id} />
      </main>
    </div>
  );
};

export default EditorEnquete;
